import { render, staticRenderFns } from "./stuResultMar.vue?vue&type=template&id=187f930f"
import script from "./stuResultMar.vue?vue&type=script&lang=js"
export * from "./stuResultMar.vue?vue&type=script&lang=js"
import style0 from "./stuResultMar.vue?vue&type=style&index=0&id=187f930f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports